<div class="bg-white" *ngIf="(homepageMessages | async)?.length > 0">
  <div class="page-container max-w-[1600px] mx-auto p-6 bg-transparent">
    <h2
      class="text-center"
      [innerHTML]="'homepage_content_messaging_title' | translate"
    ></h2>
    <p
      class="text-center"
      [innerHTML]="'homepage_content_messaging_subtitle' | translate"
    ></p>
    <zelis-horizontal-scroll
      (activeIndexChange)="activeItemIndex = $event"
      [scrollByGroup]="false"
      [disableProgressDots]="true"
      [centerFixedContent]="true"
    >
      <div class="flex flex-row justify-center gap-8">
        <zelis-callout-card
          *ngFor="
            let item of homepageMessages | async;
            trackBy: trackById;
            let i = index
          "
          zelisHorizontalScrollItem
          class="w-[300px] md:w-[479px]"
          variant="outlined"
          emphasisColor="primary"
          [title]="item.message_title"
          [subtitle]="item.message_sub_header"
        >
          <mat-icon
            class="text-palette-m3-system-gray-10"
            [svgIcon]="item.icon"
          ></mat-icon>
          <zelis-callout-card-content>
            <zelis-clamp [expanded]="false" [lines]="4">
              <div
                class="text-base expansion-panel-content"
                [innerHTML]="item.text"
              ></div>
            </zelis-clamp>
            <a
              *ngIf="item.link"
              [href]="item.link"
              target="_blank"
              mat-stroked-button
              color="accent"
              [innerHTML]="item.button_text"
            >
            </a>
          </zelis-callout-card-content>
        </zelis-callout-card>
      </div>
    </zelis-horizontal-scroll>
  </div>
</div>
